export type AppStateType = {
  token: string;
};

export const initialState: AppStateType = {
  token: "",
};
